// extracted by mini-css-extract-plugin
export default {"parentWrapper":"auth_parentWrapper__GUFWB","formHeader":"auth_formHeader__oAv4e"};